<div class="row mt-4">
    <div class="col-12">
        <label>{{label}}</label>

        <div class="input-group mb-3">
            <input type="text" class="form-control" [placeholder]="placeholder" 
                disabled
                [(ngModel)]="model"
                (keyup.enter)="modelChanged()" />
            <div class="input-group-append">
                <button class="btn btn-outline-primary" type="button" (click)="getData()">
                    <i class="fa fa-plus"></i>
                </button>
            </div>
            <div class="input-group-append">
                <button class="btn btn-outline-info" type="button" (click)="preview()" [disabled]="!model">
                    <i class="fa fa-eye"></i>
                </button>
            </div>
            <div class="input-group-append">
                <button class="btn btn-outline-danger" type="button" (click)="clear()" [disabled]="!model">
                    <i class="fa fa-remove"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" [id]="asset_modal_id" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" style="display: none;">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Select an image</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="container" style="max-height: 400px; overflow-y: auto;">
                    <div class="row mb-3">
                        <div class="col-8">
                            <label class="control-label" for="fileInput">Add new asset</label>
                            <input
                                #fileInput
                                type="file"
                                id="fileInput"
                                class="form-control"
                                accept="image/*"
                                (change)="onFileSelected($event)"
                            />
                        </div>
                        <div class="col-4 text-right pt-2">
                            <button class="btn btn-primary mt-4" (click)="uploadFile()" [disabled]="!selectedFile">
                                <i class="icon-upload icon-white"></i> Upload
                            </button>
                        </div>
                    </div>
                    <div class="row align-items-center mb-3" *ngFor="let image of assets">
                        <!-- Thumbnail -->
                        <div class="col-auto">
                            <img [src]="image.url" alt="{{ image.name }}" class="img-thumbnail" style="width: 80px; height: auto;">
                        </div>
                
                        <!-- Nome + dimensioni -->
                        <div class="col">
                            <div><strong>{{ image.name }}</strong></div>
                            <div class="text-muted">Size: {{ image.width }} × {{ image.height }} px</div>
                        </div>
                
                        <!-- Azioni -->
                        <div class="col-auto text-end">
                            <button class="btn btn-sm btn-success me-2" (click)="useImage(image.url)">
                                <i class="bi bi-check-circle"></i> Use this image
                            </button>
                            <button class="btn btn-sm btn-danger" (click)="deleteImage(image.id)">
                                <i class="bi bi-trash"></i> Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" [id]="delete_modal_id" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" style="display: none;">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Delete asset</h5>
                <button type="button" class="close" aria-label="Close" (click)="closeModal(delete_modal_id)">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Are you sure to delete this asset?</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeModal(delete_modal_id)">Cancel</button>
                <button (click)="deleteConfirm()" type="button" class="btn btn-danger">Confirm</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" [id]="preview_modal_id" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" style="display: none;">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Preview asset</h5>
                <button type="button" class="close" aria-label="Close" (click)="closeModal(preview_modal_id)">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body text-center">
                <img [src]="model" style="max-width: 400px;" [alt]="" />
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeModal(preview_modal_id)">Close</button>
            </div>
        </div>
    </div>
</div>